import React, { useEffect, useState } from "react";

//CSS
import "./sortComponent.css";

import { useTransition } from "react";
import { useTranslation } from "react-i18next";

import GetSvgIcon from "../../SvgIcons/SvgIcon";
import SvgSortIcon from "../../SvgIcons/SortIcon";
import SvgArrowIcon from "../../SvgIcons/ArrowIcon";

export default function SortComponent({
  sortOpts,
  sortOptFunctions,
  className,
}) {
  const [selectedOption, setSelectedOption] = useState(0);
  const [sortParmCollapsed, setSortParmCollapsed] = useState(true);
  const [sortDirection, setSortDirection] = useState(-1);
  const [initiated, setInitiated] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    if (
      !initiated &&
      sortOpts &&
      sortOptFunctions &&
      sortOpts.length > 0 &&
      sortOptFunctions.length > 0
    ) {
      setInitiated(true);
      setSelectedOption(0);
      sortOptFunctions[0](-sortDirection);
    }
  }, [sortOpts]);

  const onSortParmClicked = () => {
    setSortParmCollapsed(false);
  };

  const onSortDirectionClicked = () => {
    setSortDirection(-sortDirection);
    sortOptFunctions[selectedOption](sortDirection);
  };

  const createOpts = (item, index) => {
    return (
      <div
        className="sortOption"
        onClick={() => {
          sortOptFunctions[index](-sortDirection);
          setSelectedOption(index);
          setSortParmCollapsed(true);
        }}
      >
        {t(item)}
      </div>
    );
  };

  const sortParmContent = sortParmCollapsed ? (
    <div className="sortOptions collapsed">
      <div className="sortOption collapsed" onClick={onSortParmClicked}>
        {t(sortOpts[selectedOption])}
      </div>
    </div>
  ) : (
    <div className="sortOptions">{sortOpts.map(createOpts)}</div>
  );

  var container = document.getElementsByClassName("sortParm")[0];
  document.addEventListener("click", function (event) {
    if (container) {
      if (container !== event.target && !container.contains(event.target)) {
        setSortParmCollapsed(true);
      }
    }
  });

  return (
    <div className={"sort-component " + className}>
      <div className="sortIcon">
        <SvgSortIcon />
      </div>
      <div className={sortParmCollapsed ? "sortParm collapsed" : "sortParm"}>
        {sortParmContent}
      </div>
      <div className={"sortDirection"} onClick={onSortDirectionClicked}>
        <SvgArrowIcon className={sortDirection === 1 ? "up" : "down"} />
      </div>
    </div>
  );
}
